import * as React from 'react'
import CharismaTutorStudentsList from '../tutors/tutorStudentsList.tsx'
import CharismaTutorSpace from '../tutors/tutorSpace.tsx';
import Grid from '@mui/material/Grid'

import { useParams} from 'react-router-dom';    

export default function CharismaWelcomeTutor(props){
    
    let params = useParams();
    const lTrainingStudentId: number =  parseInt(params['trainingId']);
    const lPage: string =  params['page'];
    
    
    return(
        <Grid container spacing={4}>
            <Grid item xs={12} sm={2}>
                <CharismaTutorStudentsList
                    tutorId={props.tutorId}
                    studentTrainingId = {lTrainingStudentId}
                />
            </Grid>
            <Grid item xs={12} sm={10}>
                {lTrainingStudentId !== undefined && !isNaN(lTrainingStudentId) ?                                   
                    <CharismaTutorSpace
                        studentTrainingId = {lTrainingStudentId}
                        page={lPage}
                    />
                    :
                    null
                } 
            </Grid>
        </Grid>
  
    );
}